import http from "../http-common";
/* eslint-disable */
class PelatihanEvaluasiPenyelenggaraanService {
  evaluasiList(page, itemPerPage, keyword, kegiatanId) {
    return http.get(
      "/pelatihan/evaluasi-penyelenggaraan/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&kegiatan_id=" +
        kegiatanId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    return http.post("/pelatihan/evaluasi-penyelenggaraan", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  update(data) {
    return http.put(`/pelatihan/evaluasi-penyelenggaraan/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  delete(id) {
    return http.delete(`/pelatihan/evaluasi-penyelenggaraan/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new PelatihanEvaluasiPenyelenggaraanService();
